import { apiClient } from '~/services/api-service';

export const vcardMicrositeAPIService = {
  getVCardSite: (id: string | number) => {
    return apiClient.get(`/microsite/vcard-plus/${id}/`);
  },
  createVCardSite: (body) => {
    return apiClient.post(`/microsite/vcard-plus/`, body);
  },
  replaceVCardSite: ({ id, body }) => {
    return apiClient.put(`/microsite/vcard-plus/${id}/`, body);
  },
  updateVCardSite: ({ id, body }) => {
    return apiClient.patch(`/microsite/vcard-plus/${id}/`, body);
  },

  //social networks
  createVCardSocial: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/social/`, body);
  },
  updateVCardSocial: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/social/${id}/`, body);
  },
  deleteVCardSocial: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/social/${id}/`);
  },

  //person
  updateVCardPerson: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/person/${id}/`, body);
  },

  //companies
  createVCardCompany: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/company/`, body);
  },
  updateVCardCompany: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/company/${id}/`, body);
  },
  deleteVCardCompany: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/company/${id}/`);
  },

  //phones
  createVCardPhones: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/phone/`, body);
  },
  updateVCardPhones: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/phone/${id}/`, body);
  },
  deleteVCardPhones: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/phone/${id}/`);
  },

  //emails
  createVCardEmails: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/email/`, body);
  },
  updateVCardEmails: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/email/${id}/`, body);
  },
  deleteVCardEmails: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/email/${id}/`);
  },

  //website
  createVCardWebsite: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/website/`, body);
  },
  updateVCardWebsite: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/website/${id}/`, body);
  },
  deleteVCardWebsite: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/website/${id}/`);
  },
  //location
  updateVCardLocation: (body, id: string | number) => {
    return apiClient.patch(`/microsite/microsite-vcard/location/${id}/`, body);
  },
  //images
  uploadImage: (body) => {
    return apiClient.post(`/microsite/microsite-vcard/image/`, body);
  },
  removeImage: (id: string | number) => {
    return apiClient.delete(`/microsite/microsite-vcard/image/${id}`);
  },
  //contact btn
  addContact: (id: number) => {
    return apiClient.get(`/microsite/microsite-vcard/${id}/download`);
  },
};
